import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { BallCanvas } from "./canvas";
import { SectionWrapper } from "../hoc";
import { Learningtechnologies } from "../constants";

const LearningTech = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div>
        <h2
          style={{ color: "#fff", paddingBottom: "20px" }}
          className={styles.heroSubText}
        >
          Currently Learning...
        </h2>
      </div>
      <div
        style={{
          padding: "20px",
          borderRadius: "30px",
        }}
        className="flex flex-row flex-wrap justify-center gap-10 bg-slate-500"
      >
        {Learningtechnologies.map((technology) => (
          <div className="w-28 h-28" key={technology.name}>
            <BallCanvas icon={technology.icon} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionWrapper(LearningTech, "");
